/**
 * Converts a string to a URL-friendly slug
 * Example: "Rota da Morte" → "rota-da-morte"
 * 
 * @param {string} text - The text to slugify
 * @returns {string} - The slugified text
 */
export function slugify(text) {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    // Normalize accented characters (é → e, ã → a, etc.)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Replace spaces and underscores with hyphens
    .replace(/[\s_]+/g, '-')
    // Remove all non-alphanumeric characters except hyphens
    .replace(/[^a-z0-9-]/g, '')
    // Remove multiple consecutive hyphens
    .replace(/-+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '');
}

/**
 * Generates a shareable URL with ID and slug
 * 
 * @param {string} basePath - The base path (e.g., '/passeio', '/motard', '/grupo')
 * @param {string} id - The unique identifier
 * @param {string} name - The name to slugify
 * @returns {string} - The full URL path
 */
export function generateShareUrl(basePath, id, name) {
  const slug = slugify(name);
  const baseUrl = window.location.origin;
  return `${baseUrl}${basePath}/${id}/${slug}`;
}

export default slugify;
